import { P2GText } from '@parcel2go/core-ui';

export function SmallText(text: string) {
  return (
    <P2GText variant="body2" component="span" small>
      {text}
    </P2GText>
  );
}
